import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates/FullPageAppTemplate'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'

const InventoryApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.INVENTORY}
      scope='inventory'
      envKey={apps[AppId.INVENTORY].runtimeEnvKey}
      entryPath='./InventoryApp'
      url={process.env.REACT_APP_INVENTORY_APP_DEV_PATH}
      appName={apps[AppId.INVENTORY].name}
      appProps={{
        user,
        initialPath: location.pathname,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}

export { InventoryApp }
